<template>
  <div v-if="bannerSrc" class="banner">
    <a :href="bannerUrl" target="_blank">
      <img :src="bannerSrc" :alt="bannerAlt">
    </a>
  </div>
</template>

<script>
import db from '../db';
import helpers from '../helpers';

export default {
  name: 'Banner',
  data() {
    return {
      bannerSrc: undefined,
      bannerUrl: undefined,
      bannerAlt: undefined,
      presentation: undefined,
    };
  },
  props: ['presentationHash'],
  firebase: helpers.getFirebaseObject(db),
  mounted() {
    this.updateBanner();
    setInterval(this.updateBanner, 30 * 1000);
  },
  methods: {

    getPresentation() {
      if (!this.speakers) return;
      let presentations = helpers.getPresentationsByDay(this.speakers, this.options);
      return helpers.getPresentationByHash(presentations, this.presentationHash);
    },

    updateBanner() {
      let presentation = this.getPresentation();

      if (this.presentation && this.presentation === presentation) {
        return;
      }

      if (presentation && 'banner' in presentation) {
        this.bannerSrc = presentation.banner;
        this.bannerUrl = presentation.banner_url;
        this.bannerAlt = presentation.title;
        this.presentation = presentation;
        return;
      }

      // Load one of the default banners randomly
      if (this.options && 'live_banners' in this.options) {
        let banners = this.options.live_banners;
        let banner = banners[Math.floor(Math.random()*banners.length)];
        this.bannerSrc = banner.iuconf_banner_image;
        this.bannerUrl = banner.iuconf_banner_url;
        this.bannerAlt = '';
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.banner {
  margin-bottom: .5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue